import React, { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";

export interface ICustomButton {
  id: any;
  title: string;
}

interface IProps {
  onChange: (option: ICustomButton) => void;
  selected: ICustomButton[] | null;
  options: ICustomButton[];
  className?: string;
  align: "top-left" | "top-right" | "bottom-left" | "bottom-right";
}

export default function ButtonGroupCustom(props: IProps) {
  const { options, selected, className, align, onChange = () => {} } = props;
  const [selectedOptions, setSelectedOptions] = useState([""]);

  useEffect(() => {
    if (selected !== null && selected.length > 0) {
      const nextSelectedOptions = selected.map((x) => x.id);
      setSelectedOptions(nextSelectedOptions);
    } else {
      setSelectedOptions([""]);
    }
  }, [selected]);

  const handleButtonClick = (option: ICustomButton) => {
    setSelectedOptions([option.id]);
    onChange(option);
  };

  return (
    <Stack
      flexDirection="row"
      flexWrap="wrap"
      className={`${className} button-group-custom`}
      justifyContent={alignWrapper(align)}
      gap={2}
      sx={{ pb: 2 }}
    >
      {options.map((option: ICustomButton, index: number) => {
        return (
          <Button
            className={`button-group-custom__button ${align}`}
            key={index}
            variant={
              selectedOptions.includes(option.id) ? "contained" : "outlined"
            }
            onClick={() => handleButtonClick(option)}
            disableElevation
          >
            {option.title}
          </Button>
        );
      })}
    </Stack>
  );
}

const alignWrapper = (align: string) => {
  switch (align) {
    case "top-left":
      return { justifyContent: "flex-start" };
    case "top-right":
      return { justifyContent: "flex-end" };
    case "bottom-left":
      return { justifyContent: "flex-start" };
    case "bottom-right":
      return { justifyContent: "flex-end" };
  }
};
